import { IPraxisgruppeRechnungService } from './IPraxisgruppeRechnungService';
import BaseService from '@/services/baseService';
import { RechnungFilterDto } from '@/types/RechnungFilterDto';
import { TvsKundeVonZugriffeApiDto, TvsLieferantRechnungApiDtoSearchResponseApi, TvsLieferantRechnungDetailApiDto } from '@/api-schema';
import { AxiosResponse } from 'axios';

export class PraxisgruppeRechnungService extends BaseService implements IPraxisgruppeRechnungService {
    private RECHNUNGEN_URL: string;
    private DOKUMENTE_URL: string;
    private TEILNEHMERZUGRIFF_URL: string;
    constructor() {
        super();
        this.RECHNUNGEN_URL = `${this.BASE_URL}rechnungen`;
        this.DOKUMENTE_URL = `${this.BASE_URL}dokumente`;
        this.TEILNEHMERZUGRIFF_URL = `${this.BASE_URL}teilnehmerzugriff`;

        console.debug('ArchivService::constructor', this.RECHNUNGEN_URL);
    }

    async getAll(filter: RechnungFilterDto): Promise<TvsLieferantRechnungApiDtoSearchResponseApi> {
        return super
            .GET<TvsLieferantRechnungApiDtoSearchResponseApi>(`${this.RECHNUNGEN_URL}` + super.serializeObjectToQuerystring(filter))
            .then((response) => {
                return response;
            });
    }

    async getDetails(xmlDokumentGuid: string): Promise<Array<TvsLieferantRechnungDetailApiDto>> {
        return super.GET<Array<object>>(`${this.RECHNUNGEN_URL}/` + xmlDokumentGuid).then((response) => {
            return response;
        });
    }

    async downloadBeleg(id: string): Promise<AxiosResponse<File>> {
        return super.DOWNLOAD<File>(`${this.DOKUMENTE_URL}/download/` + id).then((response) => {
            return response;
        });
    }
    async downloadCsv(filter: RechnungFilterDto): Promise<AxiosResponse<File>> {
        return super.DOWNLOAD<File>(`${this.RECHNUNGEN_URL}/download/csv/` + super.serializeObjectToQuerystring(filter)).then((response) => {
            return response;
        });
    }
    async downloadXml(filter: RechnungFilterDto): Promise<AxiosResponse<File>> {
        return super.DOWNLOAD<File>(`${this.RECHNUNGEN_URL}/download/xml/` + super.serializeObjectToQuerystring(filter)).then((response) => {
            return response;
        });
    }
    async getTvsKundenVonZugriffe(): Promise<Array<TvsKundeVonZugriffeApiDto>> {
        return super.GET<Array<TvsKundeVonZugriffeApiDto>>(`${this.TEILNEHMERZUGRIFF_URL}/getTvsKundenVonZugriffe`).then((response) => {
            return response;
        });
    }
}

export const praxisgruppeRechnungService = new PraxisgruppeRechnungService();
